import classNames from 'classnames';

type DividerProps = {
  className?: string;
  vertical?: boolean;
  style?: any;
};

const Divider = ({ className, vertical, style }: DividerProps) => {
  const Tag = vertical ? 'span' : 'hr';

  return (
    <Tag
      className={classNames(
        'border-neutral-50',
        {
          'border-t': !vertical,
          'border-l': vertical,
        },
        className,
      )}
      style={style}
    />
  );
};

export default Divider;
